export interface FooterLinkType {
    href: string;
    label: string;
}

export interface SocialLinkType extends FooterLinkType {
    icon: string;
}

export interface CompanyLinkType extends FooterLinkType {
    privacySettings?: boolean | undefined;
}

export const staticSocialLinks: SocialLinkType[] = [
    {
        href: "https://twitter.com/TRUMPF_News",
        label: "Besuchen Sie TRUMPF auf X",
        icon: "logo-x",
    },
    {
        href: "https://www.facebook.com/TRUMPF.Career",
        label: "Besuchen Sie TRUMPF auf Facebook",
        icon: "logo-facebook",
    },
    {
        href: "https://www.youtube.com/user/TRUMPFtube",
        label: "Besuchen Sie TRUMPF auf YouTube",
        icon: "logo-youtube",
    },
    {
        href: "https://www.xing.com/pages/trumpf",
        label: "Besuchen Sie TRUMPF auf XING",
        icon: "logo-xing",
    },
    {
        href: "https://www.linkedin.com/company/trumpf-deutschland",
        label: "Besuchen Sie TRUMPF auf LinkedIn",
        icon: "logo-linkedin",
    },
    {
        href: "https://www.instagram.com/trumpf_deutschland/",
        label: "Besuchen Sie TRUMPF auf Instagram",
        icon: "logo-instagram",
    },
];

const companyLinks_de_DE: CompanyLinkType[] = [
    {
        href: "https://www.trumpf.com/de_DE/meta/datenschutz/",
        label: "Datenschutz",
    },
    {
        href: "https://www.trumpf.com/de_DE/meta/impressum/",
        label: "Impressum",
    },
    {
        href: "https://www.trumpf.com/de_DE/meta/copyright-und-markenzeichen/",
        label: "Copyright und Markenrecht",
    },
    {
        href: "#",
        label: "Privatsphäre-Einstellungen",
        privacySettings: true,
    },
];

const companyLinks_en_INT: CompanyLinkType[] = [
    {
        href: "https://www.trumpf.com/en_INT/meta/corporate-information/",
        label: "Corporate information",
    },
    {
        href: "https://www.trumpf.com/en_INT/meta/data-protection/",
        label: "Data protection",
    },
    {
        href: "https://www.trumpf.com/en_INT/meta/copyright-and-trademarks/",
        label: "Copyright and Trademarks",
    },
    {
        href: "https://www.trumpf.com/en_INT/mytrumpf/meta/conditions-of-use/",
        label: "Conditions of use",
    },
    {
        href: "#",
        label: "Privacy settings",
        privacySettings: true,
    },
];

const companyLinks: Record<string, CompanyLinkType[]> = {
    de_DE: companyLinks_de_DE.slice(),
    en_UK: companyLinks_en_INT.map((link) => ({
        ...link,
        href: link.href.replace("en_INT", "en_UK"),
    })),
    en_US: companyLinks_en_INT.map((link) => ({
        ...link,
        href: link.href.replace("en_INT", "en_US"),
    })),
    // Add more locales as needed
};

export const getCompanyLinks = (locale: string): CompanyLinkType[] => {
    return companyLinks[locale.replace("-", "_")] || companyLinks_en_INT;
};
